import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import QuizIcon from "@mui/icons-material/Quiz";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { getRightworkAPI } from '../requests/utilities/requests';
import { API_get_learning_quiz_summaries } from '../../../constants';
import LoadSpinner from '../../../utilities/LoadSpinner';

function AddQuizToSectionModal(props) {

  const [selectedQuiz, setSelectedQuiz] = useState("");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    maxHeight: 800,
    bgcolor: "background.paper",
    border: "2px solid #E2E8F0",
    borderRadius: "15px",
    boxShadow: 24,
    p: 4,
    overflowY: "auto",
  };

  const handleDropdownQuizSelect = (quiz) => {
    setSelectedQuiz(quiz);
  };

  const [isLoading, setIsLoading] = React.useState(false);
  const [quizzesData, setQuizzesData] = React.useState(null);

  const fetchQuizzesData = async (showLoading) => {
    setIsLoading(showLoading);
    let api_params = {
      company_id: props.homeCompany,
    };
    try {
      const res = await getRightworkAPI(API_get_learning_quiz_summaries, api_params);
      if (res.status === 200) {
        setQuizzesData(res.data.redux?.payload?.learning_quizzes);
        setIsLoading(false);
      }
    } catch (error) {
      throw Error(error);
    }
  };

  React.useEffect(() => {
    if (props.open) {
      fetchQuizzesData(true);
    }
  }, [props.open]);


  return (
    <Modal
      open={props.open}
      onClose={() => props.handleClose()}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <Box sx={style}>
        <div className="absolute right-2 top-2">
          <IconButton
            className="text-gray-400 hover:text-gray-600"
            onClick={() => props.handleClose()}
            size="small"
            sx={{ borderRadius: "8px" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
        {!isLoading ?
          <div>
            <div className="mb-6 flex items-center space-x-3">
              <QuizIcon className="text-violet-600 h-8 w-8" />
              <h3 className="text-xl font-semibold text-gray-900">Add Quiz to Section</h3>
            </div>
            <div className="mb-8">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Select Quiz
              </label>
              <p className="text-gray-600 text-sm mb-3">Select from the quizzes you have created to add to this section.</p>
              <div className="flex-1">
                <div className="w-full">
                  <Select
                    fullWidth
                    value={selectedQuiz}
                    displayEmpty
                    onChange={(e) => handleDropdownQuizSelect(e.target.value)}
                    size="small"
                    sx={{
                      borderRadius: "10px",
                      paddingY: "5px",
                      height: "45px",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6d28d9",
                      },
                    }}
                  >
                    <MenuItem disabled value="">
                      Select a quiz
                    </MenuItem>
                    {quizzesData?.map((quiz, index) => (
                      <MenuItem key={index} value={quiz}>
                        {quiz.name}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <button
                className="flex-1 px-4 py-3 rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50 transition-colors duration-200 text-sm font-medium"
                onClick={() => props.handleClose()}
              >
                Cancel
              </button>
              {selectedQuiz ? (
                <button
                  className="flex-1 px-4 py-3 rounded-lg bg-violet-600 text-white hover:bg-violet-700 transition-colors duration-200 text-sm font-medium"
                  onClick={() => {
                    props.handleQuizSelect(selectedQuiz);
                    props.handleClose();
                  }}
                >
                  Add Quiz
                </button>
              ) : (
                <button
                  className="flex-1 px-4 py-3 rounded-lg bg-gray-100 text-gray-400 cursor-not-allowed text-sm font-medium"
                >
                  Add Quiz
                </button>
              )}
            </div>
          </div> :
          <div className="w-full h-[400px]">
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <LoadSpinner />
            </div>
          </div>
        }
      </Box>
    </Modal>
  );
}

export default AddQuizToSectionModal;
